<template>
    <div v-show="visible">
        <el-dialog title="审核" :visible.sync="visible"  v-loading="loading"  :close-on-click-modal="false" :before-close="dialogClose"  width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
               <el-form-item   prop="checkStatus" label="审核状态">
                    <el-radio-group v-model="form.checkStatus">
                        <el-radio :label="2" >通过</el-radio>
                        <el-radio :label="0">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                
                <el-form-item prop="checkRemark" label="审核备注" v-if="isShowCheckRemark">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.checkRemark"
                        maxlength="100"
                        show-word-limit>
                    </el-input>
                </el-form-item> 
            </el-form>
            <div style="font-size: 14px;color: red;" v-if="!isShowCheckRemark">温馨提示：选中{{selectCount}}条数据，符合审批数据{{ accordCount }}条。</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" @click="save()">确定</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default { 
        data(){
            return{
                loading:false,
                visible: false,
                form:{
                    id:"",
                    checkRemark:"",
                    checkStatus:2
                },
                isShowCheckRemark:true,
                selectCount: 0, // 选中总数
                accordCount: 0, // 符合总数
                rules: {
                }
            }
        },
        created:function () {
        },
        methods:{
            init(scount, ids, isShowCheckRemark){
                this.visible = true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }

                // 初始值
                this.form.id = ids;
                this.form.checkStatus = 2
                this.isShowCheckRemark=isShowCheckRemark
                this.selectCount = scount
                this.accordCount = ids.split(',').length
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        let url= this.studentEvaluateIndicatorsCheckUrl;
                        let data = {
                            id: this.form.id,
                            checkStatus: this.form.checkStatus,
                            checkRemark: this.form.checkRemark,
                        };

                        // console.log("审核信息:"+JSON.stringify(data))
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/StudentCheck.vue